'use strict';

var errcode = require('err-code');

module.exports = function (curveTypes, type) {
  if (!curveTypes.includes(type)) {
    var names = curveTypes.join(' / ');
    throw errcode(new Error("Unknown curve: ".concat(type, ". Must be ").concat(names)), 'ERR_INVALID_CURVE');
  }
};